/**
 * Datenqualitätsregel für Namensfelder in den Stammdaten (Vor-/Nachname, Abteilung, Kurs,
 * Kontoinhaber) -- serverseitig durchgesetzt (siehe backend/src/domain/name.ts), hier nur für
 * sofortiges Feedback im Formular gespiegelt. Keine Freigabe/Trust-Grenze, nur UX.
 */
export function startsWithUppercase(value: string): boolean {
  const first = value.trim().charAt(0);
  return first !== '' && first === first.toUpperCase() && first !== first.toLowerCase();
}

export const UPPERCASE_HELPER_TEXT = 'Muss mit einem Großbuchstaben beginnen.';
